import { LineChart } from "@mui/x-charts/LineChart";
import { BarChart } from "@mui/x-charts/BarChart";
import { OvalLoader } from "../../../components/common/Loader";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BRAND, CHART } from "../../../constant/theme";
import tysIcon from "../../../assets/images/icons/tys.png";
import reportsIcon from "../../../assets/images/icons/reports.png";
import incomesIcon from "../../../assets/images/icons/incomes.png";

const ChartSwiper = ({ data, ovalLoading, hasPermission, dateRangeText }) => {
  const chartDataSet = data.monthWiseBusinessList || [];
  const chartDataSet1 = data.monthWise121RFlVisitorList || [];
  const chartDataSet2 = data.monthWiseIncomesExpensesList || [];

  const chartHeight = 320;

  const currencyFormatter = (val) => {
    const value = val?.value !== undefined ? val.value : val;
    if (value == null) return "";
    return `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(value)}`;
  };

  const yAxisFormatter = (val) => {
    const value = val?.value !== undefined ? val.value : val;
    if (value == null) return "";
    return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
      value,
    );
  };

  if (!hasPermission("dashboard-tyns-data-view")) {
    return null;
  }

  return (
    <div className="chart-section">
      {/* Business Achieved - Full Width Area Chart */}
      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div
              className="chart-card-icon"
              style={{ background: CHART.softIconBg, color: BRAND.primary }}
            >
              <img
                src={tysIcon}
                alt="Overall Business Achieved"
                className="chart-card-icon-image"
              />
            </div>
            <div>
              <h3 className="chart-card-title">
                Overall Business Achieved
                {dateRangeText && (
                  <span style={{ fontWeight: 400, fontSize: "0.85rem", color: "#6c757d", marginLeft: "6px" }}>
                    {dateRangeText}
                  </span>
                )}
              </h3>
              <div className="chart-card-subtitle">
                {ovalLoading ? (
                  <OvalLoader color={BRAND.primary} />
                ) : (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip className="tyntooltip">
                        {data.overallTynsAmountText || ""}
                      </Tooltip>
                    }
                  >
                    <span className="chart-card-amount">
                      {data.overallTynsAmount}
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color={BRAND.primary} />
            </div>
          ) : chartDataSet.length > 0 ? (
            <LineChart
              dataset={chartDataSet}
              xAxis={[
                {
                  scaleType: "band",
                  dataKey: "month",
                  tickPlacement: "middle",
                  tickLabelPlacement: "middle",
                },
              ]}
              yAxis={[
                {
                  valueFormatter: yAxisFormatter,
                },
              ]}
              series={[
                {
                  dataKey: "amount",
                  valueFormatter: currencyFormatter,
                  color: BRAND.primary,
                  area: true,
                  showMark: true,
                  curve: "monotoneX",
                },
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 70 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiAreaElement-root": {
                  fill: CHART.areaFill,
                },
                "& .MuiLineElement-root": {
                  strokeWidth: 2.5,
                },
                "& .MuiMarkElement-root": {
                  strokeWidth: 2,
                  scale: "0.8",
                  fill: "#fff",
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>

      {/* 121s, RFLs, TYNs, Visitors - Full Width Bar Chart */}
      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div
              className="chart-card-icon"
              style={{ background: "#e3f2fd", color: "#1976d2" }}
            >
              <img
                src={reportsIcon}
                alt="Activities Overview"
                className="chart-card-icon-image"
              />
            </div>
            <div>
              <h3 className="chart-card-title">
                Activities Overview
                {dateRangeText && (
                  <span style={{ fontWeight: 400, fontSize: "0.85rem", color: "#6c757d", marginLeft: "6px" }}>
                    {dateRangeText}
                  </span>
                )}
              </h3>
              <p className="chart-card-subtitle-text">
              Visitors, 121s, RFLs & TYNs month-wise breakdown
              </p>
            </div>
          </div>
          <div className="chart-legend-indicators">
          <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#6B5C7B" }}
              ></span>
              Visitors
            </span>
            <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#4A8F9B" }}
              ></span>
              121s
            </span>
            <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#D97D54" }}
              ></span>
              RFLs
            </span>
            <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#61A375" }}
              ></span>
              TYNs
            </span>
          </div>
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color="#1976d2" />
            </div>
          ) : chartDataSet1.length > 0 ? (
            <BarChart
              dataset={chartDataSet1}
              xAxis={[
                {
                  dataKey: "month",
                  scaleType: "band",
                  categoryGapRatio: 0.2,
                  barGapRatio: 0.05,
                },
              ]}
              yAxis={[
                {
                  valueFormatter: yAxisFormatter,
                },
              ]}
              slotProps={{ legend: { hidden: true } }}
              series={[
                {
                  dataKey: "visitor",
                  label: "Visitors",
                  color: "#6B5C7B",
                },
                {
                  dataKey: "one_to_one",
                  label: "121s",
                  color: "#4A8F9B",
                },
                {
                  dataKey: "referral",
                  label: "RFLs",
                  color: "#D97D54",
                },
                {
                  dataKey: "tyfcb",
                  label: "TYNs",
                  color: "#61A375",
                }
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 50 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiBarElement-root": {
                  rx: 4,
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>

      {/* Income vs Expense - Full Width Area Chart */}
      {hasPermission("dashboard-income-expense-data-view") && (
      <div className="chart-card">
        <div className="chart-card-header">
          <div className="chart-card-title-group">
            <div
              className="chart-card-icon"
              style={{ background: "#fce4ec", color: "#e53935" }}
            >
              <img
                src={incomesIcon}
                alt="Income vs Expense"
                className="chart-card-icon-image"
              />
            </div>
            <div>
              <h3 className="chart-card-title">
                Income vs Expense
                {dateRangeText && (
                  <span style={{ fontWeight: 400, fontSize: "0.85rem", color: "#6c757d", marginLeft: "6px" }}>
                    {dateRangeText}
                  </span>
                )}
              </h3>
              <p className="chart-card-subtitle-text">
                Monthly income and expense comparison
              </p>
            </div>
          </div>
          <div className="chart-legend-indicators">
            <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#149614" }}
              ></span>
              Income
            </span>
            <span className="chart-legend-item">
              <span
                className="chart-legend-dot"
                style={{ background: "#FF3E1D" }}
              ></span>
              Expense
            </span>
          </div>
        </div>
        <div className="chart-card-body">
          {ovalLoading ? (
            <div className="chart-loader">
              <OvalLoader color="#e53935" />
            </div>
          ) : chartDataSet2.length > 0 ? (
            <LineChart
              dataset={chartDataSet2}
              xAxis={[{ dataKey: "month", scaleType: "band" }]}
              yAxis={[
                {
                  valueFormatter: yAxisFormatter,
                },
              ]}
              slotProps={{ legend: { hidden: true } }}
              series={[
                {
                  id: "income",
                  dataKey: "income",
                  label: "Income",
                  valueFormatter: currencyFormatter,
                  color: "#149614",
                  area: true,
                  showMark: true,
                  curve: "monotoneX",
                },
                {
                  id: "expense",
                  dataKey: "expense",
                  label: "Expense",
                  valueFormatter: currencyFormatter,
                  color: "#FF3E1D",
                  area: true,
                  showMark: true,
                  curve: "monotoneX",
                },
              ]}
              height={chartHeight}
              margin={{ top: 20, right: 20, bottom: 30, left: 70 }}
              grid={{ vertical: true, horizontal: true }}
              sx={{
                "& .MuiAreaElement-series-income": {
                  fill: "rgba(20, 150, 20, 0.12)",
                },
                "& .MuiAreaElement-series-expense": {
                  fill: "rgba(255, 62, 29, 0.1)",
                },
                "& .MuiLineElement-series-income": {
                  strokeWidth: 2.5,
                },
                "& .MuiLineElement-series-expense": {
                  strokeWidth: 2.5,
                },
                "& .MuiMarkElement-root": {
                  strokeWidth: 2,
                  scale: "0.8",
                  fill: "#fff",
                },
              }}
            />
          ) : (
            <div className="chart-empty">No data available</div>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

export default ChartSwiper;
